// initialization.service.ts

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { DalService } from '@upr-web-primer/dal';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InitializationService {
  constructor(
    @Inject('RelativeUrls') private readonly relativeUrls: any,
    private readonly dalService: DalService,
    private readonly http: HttpClient,
  ) {}

  initializeApp(): Promise<any> {
    const contentOidcTokenApi = environment.contentOidcTokenApi;

    if (contentOidcTokenApi) {
      const url =
        environment.contentApiBaseUrl + this.relativeUrls.GET_CONTENTIDTOKEN;
      const params = new HttpParams()
        .set('client_id', encodeURIComponent(environment.contentLoginClientID))
        .set(
          'client_secret',
          encodeURIComponent(environment.contentLoginClientKeyID),
        )
        .set('grant_type', encodeURIComponent('client_credentials'));

      const headersInfo: Record<string, string> = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };
      const headers = new HttpHeaders(headersInfo);

      return firstValueFrom(this.http.post(url, params.toString(), { headers }))
        .then((res: any) => {
          localStorage.setItem('contentOidcToken', res?.access_token);
        })
        .catch((error) => {
          console.error('Initialization error:', error); // NOSONAR - intentional error logging for debugging
        });
    } else {
      return this.dalService.setOidcAppToken();
    }
  }
}
